/* =========================================================
   INDILOOM THEME | recent.js  (Recently viewed products)
   Product pages save handles in localStorage (key il-recent, see product.js).
   This loads each saved product's card from /products/handle?view=card-only
   only when the section scrolls near the viewport.
   ========================================================= */
(function () {
  'use strict';
  function list() { try { return JSON.parse(localStorage.getItem('il-recent') || '[]'); } catch (e) { return []; } }
  function init(sec) {
    if (sec.ilRecent) return; sec.ilRecent = true;
    var grid = sec.querySelector('[data-recent-grid]');
    var me = sec.getAttribute('data-current') || '';
    var limit = parseInt(sec.getAttribute('data-limit'), 10) || 8;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var handles = list().filter(function (h) { return h && h !== me; }).slice(0, limit);
    if (!grid || !handles.length) return;
    var load = function () {
      Promise.all(handles.map(function (h) {
        return fetch(root + 'products/' + encodeURIComponent(h) + '?view=card-only')
          .then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
      })).then(function (parts) {
        var html = parts.filter(function (p) { return p.indexOf('il-card') > -1; }).join('');
        if (!html) return;
        grid.innerHTML = html;
        sec.hidden = false;
        if (window.ilInit) window.ilInit(sec);
      });
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '500px 0px' });
      io.observe(sec.parentNode || sec); /* the section itself is hidden until filled, so watch its wrapper */
    } else { load(); }
  }
  function boot(scope) { Array.prototype.forEach.call((scope || document).querySelectorAll('[data-recent]'), init); }
  boot(document);
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
